<template>
    <div class="row" v-if="bloqueo">
        <div  class="col-md-11">
         <div  class="alert alert-warning" role="alert">                
                <h4>Para modificar los datos de la empresa, contacte con el equipo de Soporte</h4>
            </div>
            </div>
    </div>
    <div class="row">
        
        <div class="col-md-6">
            <DatosEmpresa-datos-datos :verifactu="verifactu" :bloqueo="bloqueo" :empresa="empresa" />
        </div>
        <div class="col-md-5">
            <DatosEmpresa-datos-contabilidad :verifactu="verifactu" :bloqueo="bloqueo" :empresa="empresa" />
            <DatosEmpresa-datos-facturacion :verifactu="verifactu" :bloqueo="bloqueo" :empresa="empresa" />
        </div>
    </div>
</template>
<script>
import DatosEmpresaDatosDatos from './DatosEmpresaDatosDatos.vue'
import DatosEmpresaDatosContabilidad from './DatosEmpresaDatosContabilidad.vue'
import DatosEmpresaDatosFacturacion from './DatosEmpresaDatosFacturacion.vue'
import { PwgsApi } from '../../../../services/PwgsApi';

export default {
    props: ['empresa', 'id'],
    components: {
        'DatosEmpresa-datos-datos': DatosEmpresaDatosDatos,
        'DatosEmpresa-datos-contabilidad': DatosEmpresaDatosContabilidad,
        'DatosEmpresa-datos-facturacion': DatosEmpresaDatosFacturacion,
    },
    data() {
        return {
            bloqueo: true,
            verifactu:'',
        }
    },
    methods: {
         async comprobarVerifactu(){
            const api = new PwgsApi();
            let aux = await api.get('sistema-facturacion/verifactu');
            if (aux.sistema_facturacion == 1) {
                this.verifactu = true;
            }
            else {
                this.verifactu = false;
            }
        },
        async comprobarPermisoBloqueo(){
            try{
                const api = new PwgsApi();
                const auxusuario = localStorage.getItem('usuario');
                const resppermisos = await api.get('usuarios/'+auxusuario+'/permisos');
                const permisos = resppermisos.datos || [];
                // unicamente soporte puede editar estos campos
                this.bloqueo = !permisos.some(p => p.nombre_permiso === 'soporte');
            }catch(error){
                this.bloqueo = true;
            }
        },
    },
    mounted() {
        this.comprobarVerifactu();
        this.comprobarPermisoBloqueo();
    }
}
</script>